import { render, staticRenderFns } from "./DialogThayDongHoDienNuoc.vue?vue&type=template&id=6924e2c0"
import script from "./DialogThayDongHoDienNuoc.vue?vue&type=script&lang=js"
export * from "./DialogThayDongHoDienNuoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports